import { Injectable } from '@angular/core';
import { HttpService } from './http/http.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PowerofattorneyService {

  constructor( private httpService: HttpService) { }


  samplePoaRecord(object) {
      console.log("object", object);
      // return this.http.post(environment.pssUrl + 'Investment/poaEntry', object) // When u r posting any data(i.e. Save or update do not use this type of method call)
      //         .map(res => res.json());
      var request = {
          URL: "Powerofattorney/poaEntry",
          DATA: object
      }
      return this.httpService.post(request);
  }

  getPoaData(object) {
      var request = {
          URL: 'Powerofattorney/getPoaData',
          DATA: object
      }
      return this.httpService.post(request);
  }

  getPoaDataById(id) {
      var request = {
          URL: 'Powerofattorney/getPoaById/' + id
      }
      return this.httpService.get(request);
  }

  updatePoaData(object, id) {
      var request = {
          URL: "Powerofattorney/updatePoaData/" + id,
          DATA: object
      }
      return this.httpService.post(request);
  }

  deletePoaData(id) {
      var request = {
          URL: 'Powerofattorney/deletePoaData/' + id
      }
      return this.httpService.get(request);
  }

  generatePoaDocument(object) {
      var request = {
          URL: "Powerofattorney/generatePoaDocument",
          DATA: object
      }
      return this.httpService.post(request);
  }

  downloadPoaFile(id, type) {
      var token = localStorage.getItem('token')
      window.location.href = environment.pssServerUrl + "Powerofattorney/downloadDocument/" + id + "/" + type + "/" + token;
  }
  
  downloadPoaPdfFile(id, type) {
      var token = localStorage.getItem('token')
      window.location.href = environment.pssServerUrl + "Powerofattorney/downloadPdfDocument/" + id + "/" + type + "/" + token;
  }
}
